import React from 'react';
import { ReactComponent as SuccessIcon } from 'Icons/SceenExpWizard/Success.svg';

function SucccessMessage({ text }) {
  return (
    <div
      id="succcessmessage-wrapper"
      data-testid="succcessmessage-wrapper"
      className="flex"
      style={{ width: '100%' }}
    >
      <SuccessIcon id="succcessmessage-icon" data-testid="succcessmessage-icon" />
      <div
        id={`succcessmessage-content-${text}`}
        data-testid={`succcessmessage-content-${text}`}
        style={{ color: '#008000', marginLeft: '10px' }}
      >
        {text}
      </div>
    </div>
  );
}

export default SucccessMessage;
